import { render, staticRenderFns } from "./doc-upload-modal.vue?vue&type=template&id=3d003e2c&scoped=true&"
import script from "./doc-upload-modal.ts?vue&type=script&lang=ts&"
export * from "./doc-upload-modal.ts?vue&type=script&lang=ts&"
import style0 from "./doc-upload-modal.scss?vue&type=style&index=0&id=3d003e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d003e2c",
  null
  
)

export default component.exports